import { translateFormatter } from '@/domains/core/localization/translate';
export const addToCartError = translateFormatter<{
  amount: number;
}>("{amount, plural, =1 {The product} other {Products}} could not be added to your basket. Please try again.", undefined, undefined, "en");
export const addToCartOutOfStock = translateFormatter<{
  amount: number;
}>("{amount, plural, =1 {The product} other {Products}} could not be added to your basket because {amount, plural, =1 {it's} other {some of them are}} out of stock.", undefined, undefined, "en");
export const addToCartSuccess = translateFormatter<{
  amount: number;
}>("{amount, plural, =1 {The product has} other {# products have}} been added to your cart!", undefined, undefined, "en");